export const ROOT = "/";
export const LOGIN = "login/";
